import React, { useState, useEffect, useRef } from "react";
import Pages from './Pages';

const IssueCarousel = ({ issue, count, pages, start, path, paywall }) =>  {
  
  const [slideIndex, setSlideIndex] = useState(1);
  const sliderRef = useRef(null);
  const slideWidth = 140;

  if(!pages) return null;

  const nextSlide = () => {
    if(slideIndex === count) return false;
    setSlideIndex(slideIndex + 1);
  };

  const prevSlide = () => {
    if(slideIndex === 0) return false;
    setSlideIndex(slideIndex - 1);
  };

  useEffect(() => {
    if(start) {
      sliderRef.current.querySelector('.issue-slider__list').scrollTo({ left: (slideWidth * (start - 1) )})
      setSlideIndex(parseInt(start));
    }
  }, []);

  useEffect(() => {
    sliderRef.current.querySelector('.issue-slider__list').scrollTo({ left: (slideWidth * (slideIndex - 1)), behavior: "smooth"})
  }, [slideIndex]);

  return (
    <div ref={sliderRef} className="issue-slider">
      <span className="issue-slider__arrow issue-slider__arrow--prev" disabled={ slideIndex == 1 ? true : false } onClick={() => prevSlide()}>Prev</span>
      <span className="issue-slider__arrow issue-slider__arrow--next" disabled={ slideIndex == count ? true : false } onClick={() => nextSlide()}>Next</span>
      <Pages issue={issue} count={count} pages={pages} start={start} paywall={paywall} path={path} nextSlide={nextSlide} prevSlide={prevSlide}  />
    </div> 
  )

};

export default React.memo(IssueCarousel);